import { atom } from 'recoil';

export const FcmTokenAtom = atom({
  key: 'FcmTokenAtom',
  default: ''
});
